import React, { forwardRef } from 'react';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
import styles from './PopoverBody.module.scss';
const PopoverBody = forwardRef(({ children, className, noScroll = false, testIdPrefix }, ref) => {
    const [rootClass] = getClassName({
        rootClass: 'popoverBody',
        className,
        modifiers: {
            noScroll,
        },
        styles,
    });
    return (<div className={rootClass} ref={ref} data-testid={testIdPrefix ? `${testIdPrefix}__body` : undefined}>
                {children}
            </div>);
});
PopoverBody.displayName = 'PopoverBody';
export default PopoverBody;
